import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../contexts/LanguageContext';
import './LanguageSwitcher.css';

export default function LanguageSwitcher({ className = '', compact = false }) {
  const { t } = useTranslation();
  const { language, setLanguage } = useLanguage();

  if (compact) {
    const next = language === 'pt' ? 'en' : 'pt';
    return (
      <button
        type="button"
        className={`language-switcher language-switcher--compact ${className}`.trim()}
        aria-label={`${t('common.language')}: ${language === 'pt' ? t('common.portuguese') : t('common.english')}`}
        title={next === 'en' ? t('common.english') : t('common.portuguese')}
        onClick={() => setLanguage(next)}
      >
        <span>{language === 'pt' ? 'PT' : 'EN'}</span>
      </button>
    );
  }

  return (
    <div
      className={`language-switcher ${className}`.trim()}
      role="group"
      aria-label={t('common.language')}
    >
      <button
        type="button"
        className={`language-switcher-btn${language === 'pt' ? ' is-active' : ''}`}
        aria-pressed={language === 'pt'}
        onClick={() => setLanguage('pt')}
      >
        PT
      </button>
      <button
        type="button"
        className={`language-switcher-btn${language === 'en' ? ' is-active' : ''}`}
        aria-pressed={language === 'en'}
        onClick={() => setLanguage('en')}
      >
        EN
      </button>
    </div>
  );
}
